import type { FC } from 'react';
import { CommonSelect, type SelectProps } from 'components/common';
import { Locale } from '../../constants';

interface SelectFacebookPageAttrs {
  multiples: boolean;
  placeholder: string;
}

type SelectLanguageProps = Partial<Pick<SelectProps, 'handleChange' | 'name' | 'inputLabel'> & SelectFacebookPageAttrs>;

const SelectLanguage: FC<SelectLanguageProps> =
  ({
     handleChange,
     name,
     inputLabel,
     multiples,
     placeholder,
   }) => {
    const options = Object.entries(Locale).map(([, value]) => ({
      label: value.toUpperCase(),
      value: value,
    }));

    return (
      <CommonSelect
        name={name ?? 'language'}
        inputLabel={inputLabel ?? 'Language'}
        options={options}
        handleChange={handleChange}
        placeholder={placeholder}
        multiples={multiples}
      />
    );

  };

export default SelectLanguage;